import React from 'react'
import { Flex, List, Button, Calendar } from 'antd'
import SOLENIDADE from '../img/fotos/foto1.jpg'
import { isDesktop } from 'react-device-detect'
import { CalendarOutlined } from '@ant-design/icons'

const Eventos = () => {
    return (
        <Flex vertical style={{ paddingLeft: isDesktop?50:10, paddingTop: 20, paddingRight: isDesktop ?50:10, paddingBottom: 30 }}>
            <Flex style={{ color: '#0b0b0bff', fontWeight: 600 }}>SOLENIDADE DA ACADEMIA CEARENSE DE QUÍMICA – ACQ </Flex>
            <Flex align='center' gap={5}>
                <CalendarOutlined />
                <Flex>26 de maio de 2025</Flex>
            </Flex>
            {
                isDesktop ? <Flex justify={'space-between'} gap={20} style={{ marginTop: 15 }}>
                    <Flex flex={1}>
                        <Flex vertical>
                            <p>
                                <span>
                                    &nbsp;&nbsp;A Academia Cearense de Química, ACQ, fundada em 26 de maio de 2008, completou 17 anos e recebeu 5 novos acadêmicos, <b>Diana Cristina Silva de Azevedo</b>, que ocupará a cadeira 33,
                                    <b> Iêda Nadja Silva Montenegro</b>, nova ocupante da cadeira 2,
                                    <b> Nilce Viana Gramosa Pompeu de Sousa Brasil</b>, que ocupará a cadeira 3, <b> Ronaldo Ferreira do Nascimento</b>, que ocupará a cadeira 32 e <b>Manoel Andrade Neto</b>, que ocupará a cadeira 17
                                    indicados em assembleia Geral, bem como prestar homenagem a acadêmicos falecidos e dar posse a uma nova diretoria e novo conselho fiscal.
                                </span>
                            </p>
                            <p>
                                Outro momento marcante da solenidade foi a posse do novo presidente da ACQ <b> Airton Marques da Silva</b> juntamente com os novos integrantes da Diretoria e do Conselho Fiscal, triênio 2025-2028.
                            </p>
                            <Flex vertical style={{ marginTop: 30 }}>
                                <Flex style={{ fontWeight: 600 }}> Diretoria Executiva:</Flex>
                                <Flex>Presidente: Airton Marques da Silva</Flex>
                                <Flex>Vice-Presidente: Maria Eugênia Silva Vargas</Flex>
                                <Flex>Diretora Secretária: Rosa Ferreira de Araújo Abreu</Flex>
                                <Flex>Diretor Tesoureiro: Ary Marques da Silva</Flex>
                                <Flex>Diretor Técnico-Científico: Renato Azevedo Moreira</Flex>
                                <Flex style={{ fontWeight: 600 }}>Conselho Fiscal:</Flex>
                                <Flex>Titulares: Antonio Carlos Magalhães</Flex>
                                <Flex>Antonio Renato Soares de Casimiro</Flex>
                                <Flex>João José Hiluy Filho</Flex>
                                <Flex>Suplente: Maria de Fátima Santana Neves</Flex>

                            </Flex>

                        </Flex>



                    </Flex>
                    <Flex  >
                        <img height={300} style={{ objectFit: 'cover' }} src={SOLENIDADE} alt='solenidade' />
                    </Flex>
                </Flex> : <Flex vertical>
                    <Flex  >
                        <img width={'100%'} style={{ objectFit: 'cover' }} src={SOLENIDADE} alt='solenidade' />
                    </Flex>
                       <Flex vertical>
                            <p>
                                <span>
                                    &nbsp;&nbsp;A Academia Cearense de Química, ACQ, fundada em 26 de maio de 2008, completou 17 anos e recebeu 5 novos acadêmicos, <b>Diana Cristina Silva de Azevedo</b>, que ocupará a cadeira 33,
                                    <b> Iêda Nadja Silva Montenegro</b>, nova ocupante da cadeira 2,
                                    <b> Nilce Viana Gramosa Pompeu de Sousa Brasil</b>, que ocupará a cadeira 3, <b> Ronaldo Ferreira do Nascimento</b>, que ocupará a cadeira 32 e <b>Manoel Andrade Neto</b>, que ocupará a cadeira 17
                                    indicados em assembleia Geral, bem como prestar homenagem a acadêmicos falecidos e dar posse a uma nova diretoria e novo conselho fiscal.
                                </span>
                            </p>
                            <p>
                                Outro momento marcante da solenidade foi a posse do novo presidente da ACQ <b> Airton Marques da Silva</b> juntamente com os novos integrantes da Diretoria e do Conselho Fiscal, triênio 2025-2028.
                            </p>
                            <Flex vertical style={{ marginTop: 30 }}>
                                <Flex style={{ fontWeight: 600 }}> Diretoria Executiva:</Flex>
                                <Flex>Presidente: Airton Marques da Silva</Flex>
                                <Flex>Vice-Presidente: Maria Eugênia Silva Vargas</Flex>
                                <Flex>Diretora Secretária: Rosa Ferreira de Araújo Abreu</Flex>
                                <Flex>Diretor Tesoureiro: Ary Marques da Silva</Flex>
                                <Flex>Diretor Técnico-Científico: Renato Azevedo Moreira</Flex>
                                <Flex style={{ fontWeight: 600 }}>Conselho Fiscal:</Flex>
                                <Flex>Titulares: Antonio Carlos Magalhães</Flex>
                                <Flex>Antonio Renato Soares de Casimiro</Flex>
                                <Flex>João José Hiluy Filho</Flex>
                                <Flex>Suplente: Maria de Fátima Santana Neves</Flex>

                            </Flex>

                        </Flex>

                </Flex>
            }

        </Flex>
    )
}

export default Eventos